/**
 * 화면 표시용 포맷 — 금액 · 비율은 서버 값을 그대로 쓰고 모양만 바꾼다.
 * 값이 없으면(null/undefined) 기획서 규칙대로 "—"를 보여준다.
 */
export const EMPTY = '—';

const isNil = (v: unknown): v is null | undefined =>
  v === null || v === undefined;

/** 1476703 → "1,476,703원" */
export const formatWon = (v?: number | null) =>
  isNil(v) ? EMPTY : `${Math.floor(v).toLocaleString('ko-KR')}원`;

/** 1690 → "1,690" */
export const formatNumber = (v?: number | null) =>
  isNil(v) ? EMPTY : Math.floor(v).toLocaleString('ko-KR');

/** 32 → "32%" (서버 수수료율 · 정산 비율은 이미 % 단위) */
export const formatPercent = (v?: number | null) =>
  isNil(v) ? EMPTY : `${Math.round(v * 10) / 10}%`;

/** 23 → "+23%", -8 → "-8%" */
export const formatDeltaPercent = (v?: number | null) =>
  isNil(v) ? EMPTY : `${v > 0 ? '+' : ''}${Math.round(v * 10) / 10}%`;

/** "202607" → "2026.07" */
export const formatYm = (ym?: string | null) =>
  !ym || ym.length < 6 ? EMPTY : `${ym.slice(0, 4)}.${ym.slice(4, 6)}`;

/** "202607" → "26.07" (목록의 "26.07 정산") */
export const formatShortYm = (ym?: string | null) =>
  !ym || ym.length < 6 ? EMPTY : `${ym.slice(2, 4)}.${ym.slice(4, 6)}`;

/** URL의 "2026-07" ↔ API의 "202607" */
export const toApiYm = (urlYm: string) => urlYm.replace('-', '');
export const toUrlYm = (apiYm: string) =>
  `${apiYm.slice(0, 4)}-${apiYm.slice(4, 6)}`;

/** ISO 날짜 → "2026.07.03" */
export const formatDate = (iso?: string | null) => {
  if (!iso) return EMPTY;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return EMPTY;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}.${p(d.getMonth() + 1)}.${p(d.getDate())}`;
};

/** 파일 크기 → "2.4MB" */
export const formatFileSize = (bytes: number) =>
  bytes >= 1024 * 1024
    ? `${(bytes / 1024 / 1024).toFixed(1)}MB`
    : `${Math.max(1, Math.round(bytes / 1024))}KB`;
